function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.33334 3.66668C4.15652 3.66668 3.98696 3.73691 3.86193 3.86194C3.73691 3.98696 3.66667 4.15653 3.66667 4.33334V11.6667C3.66667 11.8435 3.73691 12.0131 3.86193 12.1381C3.98696 12.2631 4.15653 12.3333 4.33334 12.3333H11.6667C11.8435 12.3333 12.013 12.2631 12.1381 12.1381C12.2631 12.0131 12.3333 11.8435 12.3333 11.6667V7.00001H13.6667V11.6667C13.6667 12.1971 13.456 12.7058 13.0809 13.0809C12.7058 13.456 12.1971 13.6667 11.6667 13.6667H4.33334C3.8029 13.6667 3.29419 13.456 2.91912 13.0809C2.54405 12.7058 2.33334 12.1971 2.33334 11.6667V4.33334C2.33334 3.80291 2.54405 3.2942 2.91912 2.91913C3.2942 2.54406 3.8029 2.33334 4.33334 2.33334H9V3.66668H4.33334Z",
  fill: "currentColor"
});

const SvgLinkOut = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLinkOut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link-out.1e8d459f.svg";
export { ForwardRef as ReactComponent };